export class ErrorCountsByCategory {
    amountOfFunctionalErrors: number;
    amountOfTechnicalErrors: number;

    constructor(amountOfFunctionalErrors: number, amountOfTechnicalErrors: number) {
        this.amountOfFunctionalErrors = amountOfFunctionalErrors;
        this.amountOfTechnicalErrors = amountOfTechnicalErrors;
    }
}
